var baseURL
var accessKeyID
var accessKey
var baseContext
var activityId
let pcAppLoginUrl
let pcAppLoginCallBakUrl
let pcBaseUrl
let pcVipUrl
let prizeIds
let assistShareId
var host
let articleUrl
let payConfig
let laborDayRuleId
let duanWuRuleId
let loginUrl
let winterOlympic
let ruleUrl
let picUrl

if (process.env.ENV_CONFIG === 'development' || process.env.ENV_CONFIG === 'test') {
    baseURL = 'http://223.111.8.117:38080/'
        // baseURL = 'https://betagame.migufun.com/'
        // baseURL = 'http://betagame.migufun.com/'     //现网
        // baseURL = 'http://graygame.migufun.com/'
        // baseURL = 'http://betagame-ys.migufun.com/'
    accessKeyID = '7f64350ef76'
    accessKey = 'a8c14c093f7d0a3c583e2e6a47304d37'
    baseContext = 'http://223.111.8.117:38080/miguplay/'
    activityId = '8000'
    pcAppLoginUrl = 'https://union-passport.migu-net.cn'
    pcAppLoginCallBakUrl = 'http%3a%2f%2fpctest.migufun.com%3a8089%2fproxy'
    pcBaseUrl = 'http://pctest.migufun.com:8089'
    pcVipUrl = 'http://172.18.171.59/member'
    prizeIds = [16201, 16202, 16203, 16204, 16205, 16207, 16208];
    assistShareId = 25262;
    host = 'http://h5test.migufun.com:8008/miguplay';
    articleUrl = 'http://h5test.migufun.com:8008/miguplay/html/appSystemHtml/game/article.html'; // 测试
    payConfig = { // 测试
        channelId: '41579000',
        contentId: '609516058233'
    };
    // payConfig = { // 现网
    //   channelId:'10011000',
    //   contentId:'608716069205'
    // };
    laborDayRuleId = 25;
    duanWuRuleId = 25;
    winterOlympic = {
        activityFlag: 'winterOlympic',
        activityId: '20000',
        shareId: 36263, // 0119迭代修改
        ruleId: 164006,
        downloadUrl: 'https://www.migufun.com/h5/cloudgame/appdownload/appDownload.html?ADTAG=aOn',
        newsUrl: 'https://g.migufun.com/da-ayzx',
    }
    loginUrl = 'https://union-passport.migu-net.cn/';
    ruleUrl = 'http://h5test.migufun.com:8008/miguplay/html/appSystemHtml/game/rule.html';
    picUrl = 'https://pictures.cmgame.com:18081/resource/beta';
} else {
    baseURL = 'https://betagame.migufun.com/' // 现网 
        // baseURL = 'http://graygame.migufun.com/' // 灰度
        // beta
    accessKeyID = '1e536667ec3'
    accessKey = '77a626f87a9ceac9b7d8cb03bb899007'
        // alpha
        // accessKeyID = 'D4F92FE4CFC'
        // accessKey = '625a706566676a397432573238557444'
    baseContext = 'http://g.10086.cn/miguplay/'
    activityId = '10000'
    pcAppLoginUrl = 'https://passport.migu.cn'
    pcAppLoginCallBakUrl = 'https%3a%2f%2fpc-login.migufun.com%3a8088%2fproxy'
    pcBaseUrl = 'https://pc-api.migufun.com:8089'
    pcVipUrl = 'https://pc.migufun.com/member'
    prizeIds = [21010, 21012, 21005, 21004, 21003, 21002, 21001];
    assistShareId = 116264;
    host = 'https://www.migufun.com/miguplay';
    articleUrl = 'https://www.migufun.com/h5/cloudgame/game/article.html'; // 生产
    payConfig = {
        channelId: '10011000',
        contentId: '608716069205'
    };
    laborDayRuleId = 35;
    duanWuRuleId = 38;
    winterOlympic = {
        activityFlag: 'winterOlympic',
        activityId: '70003',
        shareId: 348267, // 0119迭代修改
        ruleId: 164006,
        downloadUrl: 'https://www.migufun.com/h5/cloudgame/appdownload/appDownload.html?ADTAG=aOn',
        newsUrl: 'https://g.migufun.com/da-ayzx',
    }
    loginUrl = 'https://passport.migu.cn/';
    ruleUrl = 'https://www.migufun.com/h5/cloudgame/game/rule.html';
    picUrl = 'https://freeserver.migufun.com/resource/beta';
}
export default {
    baseURL: baseURL,
    baseContext: baseContext,
    accessKey: accessKey,
    accessKeyID: accessKeyID,
    activityId: activityId,
    pcAppLoginUrl,
    pcAppLoginCallBakUrl,
    pcBaseUrl,
    pcVipUrl,
    prizeIds,
    assistShareId,
    host,
    articleUrl,
    payConfig,
    laborDayRuleId,
    duanWuRuleId,
    winterOlympic,
    loginUrl,
    ruleUrl,
    picUrl,
}


// WEBPACK FOOTER //
// ./src/config.js